exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".navbar {\n  margin-bottom: 0px;\n  background: #FFFFFF;\n}\n\n.navbar .container{\n    width: 100%;\n}\n\n.navbar-brand {\n  width: 175px;\n  position: relative;\n}\n\n.navbar-brand>img {\n    position: absolute;\n    margin: auto auto auto 0px;\n    max-width: 100%;\n    max-height: 100%;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 15px;\n}\n\n@media only screen and (min-width: 768px){\n  .buttons-container {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-direction: row;\n        flex-direction: row;\n    -ms-flex-align: center;\n        align-items: center;\n  }\n}\n\na {\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/evaluation/navbar/navbar.component.css
// module id = 788
// module chunks = 0